// @flow
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import SimpleLayout from './SimpleLayout';
import MainLayout from './MainLayout';

type Props = {
  children: React.Node
};

export default class Layout extends React.Component<Props> {
  renderSimpleLayoutRoute = (route: string) => (
    <Route
      path={`/${route}`}
      render={routeProps => (
        <SimpleLayout {...routeProps}>{this.props.children}</SimpleLayout>
      )}
    />
  );
  render() {
    return (
      <Switch>
        {this.renderSimpleLayoutRoute('signin')}
        {this.renderSimpleLayoutRoute('password_resets')}
        {this.renderSimpleLayoutRoute('error')}
        {this.renderSimpleLayoutRoute('page_not_found')}
        {this.renderSimpleLayoutRoute('maintenance')}
        <Route
          path="/"
          render={routeProps => (
            <MainLayout {...routeProps}>{this.props.children}</MainLayout>
          )}
        />
      </Switch>
    );
  }
}
